export default "__VITE_ASSET__DuATG6Yl__"